export default "__VITE_ASSET__cKCCfLXA__"